export default __webpack_public_path__ + "static/wvs-logo-ba568f4612dc36c6e81ed6c5151b18ec.svg";